import { PHONE_DISPLAY } from "../constants/content";

const ITEMS = [
    "Top cash paid on the spot",
    "Free flatbed towing in Toronto & GTA",
    `Call ${PHONE_DISPLAY}`,
    "We buy any condition vehicle",
    "Paperwork handled for you",
    "Same-day pickup, 7 days a week",
];

const Row = () => (
    <div className="flex shrink-0 items-center">
        {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center">
                <span className="mx-8 font-display font-extrabold uppercase tracking-wide text-lg sm:text-xl text-white whitespace-nowrap">
                    {item}
                </span>
                <span className="text-white text-xl">✦</span>
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="editorial-marquee"
        className="relative overflow-hidden bg-[#FF3B30] py-5 border-y-4 border-[#0B0C10] -rotate-1 scale-[1.02]"
    >
        <div className="flex w-max animate-marquee-slow">
            <Row />
            <Row />
        </div>
    </div>
);
